import script from "./OrderCustomerActions.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCustomerActions.vue?vue&type=script&setup=true&lang=js"

import "./OrderCustomerActions.vue?vue&type=style&index=0&id=65297033&scoped=true&lang=css"
import "./OrderCustomerActions.vue?vue&type=style&index=1&id=65297033&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65297033"]])

export default __exports__